<div class="p-2">
    <div class="font-semibold text-2xl mb-3" data-clarity-unmask="true">Abonamenty</div>
    <div class="main-card p-3">
      <p-button
        class="flex justify-content-end pb-2"
        label="Zakup abonament"
        icon="pi pi-plus"
        iconPos="left"
        [loading]="loading"
        (onClick)="goToBuySubscriptionsModal(null)"
        data-clarity-unmask="true"
      ></p-button>
      <p-tabView [(activeIndex)]="activeIndex" styleClass="tabview-lg">
        <p-tabPanel header="Dostępne abonamenty">
          <ng-container *ngIf="activeIndex === 0">
            <app-osk-available-subscriptions-list (buyCurrentSubscriptionEvent)="goToBuySubscriptionsModal($event)"></app-osk-available-subscriptions-list>
          </ng-container>
        </p-tabPanel>
        <p-tabPanel header="Historia">
          <ng-container *ngIf="activeIndex === 1">
            <app-osk-history-subscriptions-list></app-osk-history-subscriptions-list>
          </ng-container>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div> 